'use client'

import React from 'react'
import { ArrowUpRight } from 'lucide-react'
import { trackCtaClicked } from '../../lib/analytics'

interface CTAButtonsProps {
  secondaryText: string
  secondaryLink: string
}

export function CTAButtons({ secondaryText, secondaryLink }: CTAButtonsProps) {
  return (
    <div className="flex flex-col-reverse sm:flex-row items-center justify-center gap-3 md:gap-4 max-sm:mt-6">
      <a
        href={secondaryLink}
        onClick={() =>
          trackCtaClicked({
            cta_text: secondaryText,
            cta_location: 'mid_page',
            destination_url: secondaryLink,
          })
        }
        className="inline-flex items-center gap-2 px-6 md:px-8 py-2.5 md:py-3 bg-white text-primary rounded-full hover:bg-gray-100 transition-all font-medium text-sm md:text-base w-full sm:w-auto justify-center"
      >
        {secondaryText}
        <ArrowUpRight className="w-4 md:w-5 h-4 md:h-5" />
      </a>
      <a
        href="/eligibility"
        onClick={() =>
          trackCtaClicked({
            cta_text: 'Start Assessment',
            cta_location: 'mid_page',
            destination_url: '/eligibility',
          })
        }
        className="inline-flex items-center gap-2 px-6 md:px-8 py-2.5 md:py-3 bg-transparent text-white rounded-full border border-white hover:bg-white/10 transition-all font-medium text-sm md:text-base w-full sm:w-auto justify-center"
      >
        Start Assessment
        <ArrowUpRight className="w-4 md:w-5 h-4 md:h-5" />
      </a>
    </div>
  )
}
